import React, { FC } from 'react';
import { Text, View } from 'react-native';
import { DOT_SIZE } from '@v2/pages/dashboard/common/components/DashboardLegend/constants';
import { DashboardLegendProps } from '@v2/pages/dashboard/common/components/DashboardLegend';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';


interface LegendItemProps extends Pick<DashboardLegendProps, 'C'> {
	dotColor: string;
	label: string;
}

const LegendItem: FC<LegendItemProps> = ({ C, dotColor, label }) => (
	<View style={{ flexDirection: 'row', alignItems: 'center', gap: scale(4) }}>
		<View style={{ width: scale(DOT_SIZE), height: scale(DOT_SIZE), borderRadius: scale(1), backgroundColor: C(dotColor) }} />
		<Text style={[font['Caption 2'], { color: C('Label/Light/Tertiary') }]}>{label}</Text>
	</View>
);

export default LegendItem;